/** @jsx jsx */
import PropTypes from 'prop-types'
import { Box, Heading, jsx } from 'theme-ui'
import ContentFaqQuestion from '~/components/Content/Faq/Question'

const ContentFaqTopic = ({ topic }) => {
  const { name, questions, slug } = topic

  return (
    <Box>
      <Box
        id={slug}
        sx={{
          display: 'block',
          height: '0px',
          position: 'relative',
          top: '-128px',
          visibility: 'hidden',
          width: '0px',
        }}
      ></Box>
      {name && (
        <Heading as="h2" mb={[3, 4]} variant="title2">
          {name}
        </Heading>
      )}
      <Box sx={{ borderBottom: '1px solid', borderBottomColor: 'greyLight' }}>
        {questions &&
          questions.map((question, index) => {
            return (
              <Box
                key={index}
                sx={{ borderTop: '1px solid', borderTopColor: 'greyLight' }}
              >
                <ContentFaqQuestion key={question.id} question={question} />
              </Box>
            )
          })}
      </Box>
    </Box>
  )
}

export default ContentFaqTopic

ContentFaqTopic.propTypes = {
  faq: PropTypes.shape({
    name: PropTypes.string,
    questions: PropTypes.array,
  }),
}
